import { SMSStatusStore } from '@stores/SMSStatusStore';
import { apiResponse } from '@stores';
import { useMutation } from '@tanstack/react-query';

export class SMSStatusChangeAction {
  constructor(private readonly smsStatusStore: SMSStatusStore = new SMSStatusStore()) {}

  public async execute(status: 'OPT-IN' | 'OPT-OUT') {
    await apiResponse.handleApiResponse(async () => this.smsStatusStore.updateStatus(status));
  }
}

export const useSMSStatusChangeAction = () =>
  useMutation({
    mutationFn: async (status: 'OPT-IN' | 'OPT-OUT') => {
      const action = new SMSStatusChangeAction();
      return action.execute(status);
    },
  });
